const DIGITS_ONLY = /\D/g;

/**
 * Converts user-entered text to a non-negative whole-number price.
 * Formatting separators and any other non-digit characters are ignored.
 */
export const parseWholePrice = (value: string): number => {
  const digits = value.replace(DIGITS_ONLY, "");
  return digits ? Number(digits) : 0;
};

/** Formats a price as a non-negative whole number with comma separators. */
export const formatWholePrice = (
  value: number | null | undefined,
): string => {
  const numericValue = Number(value);
  const normalizedValue = Number.isFinite(numericValue)
    ? Math.max(0, Math.round(numericValue))
    : 0;

  return normalizedValue.toLocaleString("en-US");
};

/** Formats a price for read-only monetary displays. */
export const formatYen = (value: number | null | undefined): string =>
  `¥${formatWholePrice(value)}`;

